/**
 * @generated SignedSource<<221f238bb37463dd1b4152150bfc8ff9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetEmployeeRoleOverviewListItem_role$data = {
  readonly employees: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee">;
  }>;
  readonly id: string;
  readonly name: string;
  readonly team: {
    readonly color: string | null;
    readonly id: string;
    readonly name: string;
  };
  readonly " $fragmentType": "WidgetEmployeeRoleOverviewListItem_role";
};
export type WidgetEmployeeRoleOverviewListItem_role$key = {
  readonly " $data"?: WidgetEmployeeRoleOverviewListItem_role$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeRoleOverviewListItem_role">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetEmployeeRoleOverviewListItem_role",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "team",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "employees",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Avatar_employee"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EmployeeRole",
  "abstractKey": null
};
})();

(node as any).hash = "1d624b35ae23d89e9ff68216ba2e41d4";

export default node;
